import React, { useState, useEffect } from 'react';
import Navbar from './components/Navbar';
import Sidebar from './components/Sidebar';
import Hero from './components/Hero';
import About from './components/About';
import Features from './components/Features';
// import Services from './components/Services';
// import Pricing from './components/Pricing';
import Sponsors from './components/Sponsors';
import Support from './components/Support';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import { ThemeProvider } from './context/ThemeContext';
import DownloadApp from "./components/DownloadApp";

function App() {
  const [isOpen, setIsOpen] = useState(false);

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  // 禁止侧边栏打开时的背景滚动
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  return (
    <ThemeProvider defaultTheme="light">
      <div className="min-h-screen bg-white dark:bg-gray-900 transition-colors duration-300">
        <Navbar toggle={toggle} />
        <Sidebar isOpen={isOpen} toggle={toggle} />
        <Hero />
        <DownloadApp />
        <About />
        <Features />
        {/*<Services />*/}
        {/*<Pricing />*/}
        <FAQ />
        <Support />
        {/*<Sponsors />*/}
        <Footer />
      </div>
    </ThemeProvider>
  );
}

export default App;
